import React from 'react';
import GuidedCampaignPayment from './components/GuidedCampaignPayment.js';
import connect from './connect';
import { Elements } from 'react-stripe-elements'; 
import './assets/GuidedCampaignPayment.css';

const Component = connect(GuidedCampaignPayment);

const ComponentWithElements = (props) => (
  <Elements>
    <Component {...props} />
  </Elements>
);

export default ComponentWithElements;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignPayment/index.js